import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    useTheme,
    useMediaQuery,
    } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoginForm from "./LoginForm";
import CadastroForm from "./CadastroForm";
import ForgotPassword from "../ForgotPassword/ForgotPassword";

const Login = ({ open, handleClose, onSuccess, disableClose }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [forgotOpen, setForgotOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const goldColor = "#d6b827";
    const blueColor = "#5dade2";

    const handleForgotPassword = () => {
        handleClose(); 
        setForgotOpen(true); 
    }
    return (
        <>
            <Dialog
                open={open}
                onClose={disableClose ? () => {} : handleClose}
                maxWidth={isMobile ? "xs" : "sm"}
                fullWidth
                PaperProps={{
                    sx: {
                    borderRadius: "12px",
                    position: "relative",
                    paddingRight: "12px",
                    minWidth: isMobile ? "auto" : 400,
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: 12,
                        height: "100%",
                        backgroundColor: blueColor,
                        borderTopRightRadius: "12px",
                        borderBottomRightRadius: "12px",
                    },
                    },
                }}
                >
                <DialogTitle
                    sx={{
                    position: "relative",
                    fontWeight: "bold",
                    fontSize: 22,
                    color: isLogin ? blueColor : goldColor,
                    px: 4,
                    pt: 4,
                    pb: 2,
                    textAlign: "left",
                    }}
                >
                    {isLogin ? "ENTRAR" : "CADASTRO"}
                    {!disableClose && (
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "#707070 !important",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    )}
                </DialogTitle>
                <DialogContent sx={{ px: 4, pb: 4, maxHeight: "70vh" }}>
                    {isLogin ? (
                    <LoginForm setIsLogin={setIsLogin} onSuccess={onSuccess} handleClose={handleClose} onForgotPassword={handleForgotPassword}  />
                    ) : (
                    <CadastroForm setIsLogin={setIsLogin} onSuccess={onSuccess} />
                    )}
                </DialogContent>
            </Dialog>
            <ForgotPassword
                open={forgotOpen}
                handleClose={() => setForgotOpen(false)}
            />
                
        </>
    );
};

export default Login;
